import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionFinanceByTrialInstitutionId: ITrialInstitutionFinanceLoadByTrialInstitutionIdActionCreator = (trialInstitutionId) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_TRIAL_INSTITUTION_ID,
            trialInstitutionId
        }
    },
    LoadTrialInstitutionFinanceById: ITrialInstitutionFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionFinance: ITrialInstitutionFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionFinance: ITrialInstitutionFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionFinance: ITrialInstitutionFinanceCreateActionCreator = (trialInstitutionId) => {

        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_CREATE,
            trialInstitutionId
        }
    },
    CreateSuccess: ITrialInstitutionFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialInstitutionFinance: ITrialInstitutionFinanceSyncActionCreator = (trialInstitutionId) => {

        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_SYNC,
            trialInstitutionId
        }
    },
    SyncSuccess: ITrialInstitutionFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialInstitutionFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_TRIAL_INSTITUTION_ID = "ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_TRIAL_INSTITUTION_ID",
    ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONFINANCE_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONFINANCE_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONFINANCE_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONFINANCE_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONFINANCE_SAVE = "ACTION_TRIALINSTITUTIONFINANCE_SAVE",
    ACTION_TRIALINSTITUTIONFINANCE_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONFINANCE_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONFINANCE_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONFINANCE_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONFINANCE_VALIDATE = "ACTION_TRIALINSTITUTIONFINANCE_VALIDATE",
    ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONFINANCE_CREATE = "ACTION_TRIALINSTITUTIONFINANCE_CREATE",
    ACTION_TRIALINSTITUTIONFINANCE_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONFINANCE_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONFINANCE_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONFINANCE_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONFINANCE_SYNC = "ACTION_TRIALINSTITUTIONFINANCE_SYNC",
    ACTION_TRIALINSTITUTIONFINANCE_SYNC_SUCCESS = "ACTION_TRIALINSTITUTIONFINANCE_SYNC_SUCCESS",
    ACTION_TRIALINSTITUTIONFINANCE_SYNC_FAILURE = "ACTION_TRIALINSTITUTIONFINANCE_SYNC_FAILURE",

    ACTION_TRIALINSTITUTIONFINANCE_CLEAR = "ACTION_TRIALINSTITUTIONFINANCE_CLEAR",

    ACTION_TRIALINSTITUTIONFINANCE_FILTER = "ACTION_TRIALINSTITUTIONFINANCE_FILTER";

export interface ITrialInstitutionFinanceLoadByTrialInstitutionIdAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_TRIAL_INSTITUTION_ID";
    trialInstitutionId: number;
}

export interface ITrialInstitutionFinanceLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId: number): ITrialInstitutionFinanceLoadByTrialInstitutionIdAction;
}

export interface ITrialInstitutionFinanceLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionFinance | Dtos.TrialInstitutionFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance | Dtos.TrialInstitutionFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionFinanceLoadSuccessAction;
}

export interface ITrialInstitutionFinanceLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionFinanceLoadFailureAction;
}

export interface ITrialInstitutionFinanceLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionFinanceLoadByIdActionCreator {
    (id: number): ITrialInstitutionFinanceLoadByIdAction;
}

export interface ITrialInstitutionFinanceSaveAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_SAVE";
    formData: Dtos.TrialInstitutionFinance;

}

export interface ITrialInstitutionFinanceSaveActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance
    ): ITrialInstitutionFinanceSaveAction;
}

export interface ITrialInstitutionFinanceSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionFinanceSaveSuccessAction;
}

export interface ITrialInstitutionFinanceSaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionFinanceSaveFailureAction;
}

export interface ITrialInstitutionFinanceValidateAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_VALIDATE";
    formData: Dtos.TrialInstitutionFinance;

}

export interface ITrialInstitutionFinanceValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance
    ): ITrialInstitutionFinanceValidateAction;
}

export interface ITrialInstitutionFinanceValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionFinanceValidateSuccessAction;
}

export interface ITrialInstitutionFinanceValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionFinanceValidateFailureAction;
}

export interface ITrialInstitutionFinanceCreateAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_CREATE",
    trialInstitutionId: number
}

export interface ITrialInstitutionFinanceCreateActionCreator {
    (trialInstitutionId: number): ITrialInstitutionFinanceCreateAction
}

export interface ITrialInstitutionFinanceCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionFinanceCreateSuccessAction;
}

export interface ITrialInstitutionFinanceCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionFinanceCreateFailureAction;
}

export interface ITrialInstitutionFinanceClearAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionFinanceClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionFinanceClearAction;
}

export interface ITrialInstitutionFinanceFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionFinanceFilterAction;
}

export interface ITrialInstitutionFinanceFilterAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialInstitutionFinanceSyncAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_SYNC",
    trialInstitutionId: number
}

export interface ITrialInstitutionFinanceSyncActionCreator {
    (trialInstitutionId: number): ITrialInstitutionFinanceSyncAction
}

export interface ITrialInstitutionFinanceSyncSuccessAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_SYNC_SUCCESS";
    formData: Dtos.TrialInstitutionFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionFinanceSyncSuccessAction;
}

export interface ITrialInstitutionFinanceSyncFailureAction {
    type: "ACTION_TRIALINSTITUTIONFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionFinanceSyncFailureAction;
}

export type TrialInstitutionFinanceAction =
    ITrialInstitutionFinanceLoadByTrialInstitutionIdAction |
    ITrialInstitutionFinanceLoadByIdAction |
    ITrialInstitutionFinanceLoadFailureAction |
    ITrialInstitutionFinanceLoadSuccessAction |
    ITrialInstitutionFinanceSaveAction |
    ITrialInstitutionFinanceSaveSuccessAction |
    ITrialInstitutionFinanceSaveFailureAction |
    ITrialInstitutionFinanceValidateAction |
    ITrialInstitutionFinanceValidateSuccessAction |
    ITrialInstitutionFinanceValidateFailureAction |
    ITrialInstitutionFinanceCreateAction |
    ITrialInstitutionFinanceCreateSuccessAction |
    ITrialInstitutionFinanceCreateFailureAction |
    ITrialInstitutionFinanceSyncAction |
    ITrialInstitutionFinanceSyncSuccessAction |
    ITrialInstitutionFinanceSyncFailureAction |
    ITrialInstitutionFinanceClearAction | 
    ITrialInstitutionFinanceFilterAction;
